import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, input } from '@angular/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { AdyenPayoutMethodStatus } from '@app/modules/direct/services/payout-methods.service';
import { Property } from '@app/shared/interfaces';
import { CsDebugItemComponent } from '@app/ui';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { BadgeComponent } from '@ui';
import { UiModule } from '../ui.module';

export interface PaymentCardAction {
  id: string;
  label: string;
  classes?: string;
}

export { AdyenPayoutMethodStatus };

@Component({
  selector: 'sbnb-payout-method-card',
  templateUrl: './payout-method-card.component.html',
  standalone: true,
  imports: [CommonModule, UiModule, MatMenuModule, SatPopoverModule, BadgeComponent, CsDebugItemComponent],
})
export class PayoutMethodCardComponent {
  AdyenPayoutMethodStatus = AdyenPayoutMethodStatus;

  accountName = input.required<string>();
  status = input.required<AdyenPayoutMethodStatus>();
  isDefault = input<boolean>(false);
  actions = input<PaymentCardAction[]>([]);
  verificationErrors = input<string[]>([]);
  accountHolderId = input<string | null>(null);
  lastFour = input<string | null>(null);
  bankName = input<string | null>(null);
  properties = input<Property[] | null | undefined>(undefined);
  allProperties = input<boolean>(false);

  @Output() actionClicked = new EventEmitter<string>();

  onActionClick(actionId: string): void {
    this.actionClicked.emit(actionId);
  }
}
